/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetAdminDashboard200Response,
} from '../models/index';
import {
    GetAdminDashboard200ResponseFromJSON,
    GetAdminDashboard200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class DashboardApi extends runtime.BaseAPI {

    /**
     * get dashboard stats
     */
    async getAdminDashboardRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAdminDashboard200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAdminDashboard200ResponseFromJSON(jsonValue));
    }

    /**
     * get dashboard stats
     */
    async getAdminDashboard(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAdminDashboard200Response> {
        const response = await this.getAdminDashboardRaw(initOverrides);
        return await response.value();
    }

}
